import { Controller } from "@hotwired/stimulus"
import { debounce } from "../application"

export default class extends Controller {
    static targets = ["searchForm"]

    connect() {
        this.debouncedSubmitSearch = debounce(() => {
            this.searchFormTarget.requestSubmit()
        }, 300)
    }

    autoSubmitSearch() {
        this.debouncedSubmitSearch()
    }
}
